import { render, staticRenderFns } from "./deceiveTypeTemplate.vue?vue&type=template&id=893dc2cc&scoped=true&"
import script from "./deceiveTypeTemplate.vue?vue&type=script&lang=js&"
export * from "./deceiveTypeTemplate.vue?vue&type=script&lang=js&"
import style0 from "./deceiveTypeTemplate.vue?vue&type=style&index=0&id=893dc2cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893dc2cc",
  null
  
)

export default component.exports